export default __webpack_public_path__ + "static/media/img-0720-estonia-full-face.55b8cd99.png";